import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Loader from "../components/common/loader/Loader";
import { UserContext } from "../contexts/UserContext";

export default function GameStatus(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const [idGame, setIdGame] = React.useState(0);
  const [sportType, setSportType] = React.useState(0);
  const [shortGame, setShortGame] = React.useState(0);
  const [gameStatus, setGameStatus] = React.useState("");
  const [contenderStatus, setContenderStatus] = React.useState(0);
  const [system, setSystem] = React.useState(0);
  const [local, setLocal] = React.useState(false);
  const [online, setOnline] = React.useState(false);
  const [noHookUps, setNoHookUps] = React.useState(false);
  const [noRelated, setNoRelated] = React.useState(false);
  const [dateChanged, setDateChanged] = React.useState(false);
  const [timeChanged, setTimeChanged] = React.useState(false);
  const [isShortGame, setIsShortGame] = React.useState(false);
  const [acceptAutoChanges, setAcceptAutoChanges] = React.useState(false);
  const [pitcherChanged, setPitcherChanged] = React.useState(false);
  const [completedGame, setCompletedGame] = React.useState("");
  const [homeNumber, setHomeNumber] = React.useState(0);
  const [homeTeam, setHomeTeam] = React.useState(0);
  const [homeScore, setHomeScore] = React.useState(0);
  const [visitorNumber, setVisitorNumber] = React.useState(0);
  const [visitorTeam, setVisitorTeam] = React.useState(0);
  const [visitorScore, setVisitorScore] = React.useState(0);
  const [idUser, setIdUser] = React.useState(0);
  const [result, setResult] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [selectedValueTime, setSelectedValueTime] = React.useState("None");
  const [gamesTNT, setGamesTNT] = React.useState("None");
  const [selectedIdProfile, setSelectedIdProfile] = useState(props.rotation);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedValueStatus, setSelectedValueStatus] =
    React.useState("Visitor");
  const [flag, setFlag] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const [selectedValueAutoChanges, setSelectedValueAutoChanges] =
    React.useState("Visitor");

  const [selectedWinner, setSelectedWinner] = useState(0);

  const handleChangeStatus = (event) => {
    setGameStatus(event.target.value);
  };
  const handleChangeContenderStatus = (event) => {
    setContenderStatus(event.target.value);
    setFlag(true);
    // if (event.target.value == "0") {
    //   setFlag(true);
    // }
  };

  const handleChangeVisitorNumber = (event) => {
    setVisitorNumber(event.target.value);
  };

  const handleChangeVisitorTeam = (event) => {
    setVisitorTeam(event.target.value);
  };

  const handleChangeVisitorScore = (event) => {
    setVisitorScore(event.target.value);
  };

  const handleChangeHomeNumber = (event) => {
    setHomeNumber(event.target.value);
  };

  const handleChangeHomeTeam = (event) => {
    setHomeTeam(event.target.value);
  };

  const handleChangeHomeScore = (event) => {
    setHomeScore(event.target.value);
  };
  const handleChangeCompletedGame = (event) => {
    setCompletedGame(event.target.value);
  };
  const handleChangeTime = (event) => {
    setSelectedValueTime(event.target.value);
  };
  const handleChangeAutoChangesRadio = (event) => {
    setSelectedValueAutoChanges(event.target.value);
  };

  const handleIdGame = () => {
    setIdGame(!idGame);
  };

  const handleChangeLocal = () => {
    setLocal(!local);
  };
  const handleChangeOnline = () => {
    setOnline(!online);
  };
  const handleChangeNoHookUps = () => {
    setNoHookUps(!noHookUps);
  };
  const handleChangeNoRelated = () => {
    setNoRelated(!noRelated);
  };
  const handleChangeDateChanged = () => {
    setDateChanged(!dateChanged);
  };
  const handleChangeTimeChanged = () => {
    setTimeChanged(!timeChanged);
  };
  const handleShortGame = () => {
    setIsShortGame(!isShortGame);
  };
  const handleChangeAcceptAutoChanges = () => {
    setAcceptAutoChanges(!acceptAutoChanges);
  };

  const handlePitcherChanged = (event) => {
    setPitcherChanged(event.target.value);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };

  const handleIdProfileChange = (event) => {
    const teamNumberSeleccionado = event.target.value;
    setSelectedIdProfile(teamNumberSeleccionado);

    // Buscar el objeto completo en gamesTNT usando el TeamNumber
    const rowSeleccionado = gamesTNT.find(row => row.teamNumber === teamNumberSeleccionado);
    console.log(rowSeleccionado)
    if (rowSeleccionado) {
      let status;
      if (rowSeleccionado.detailResult === 0) {
        status = "0";
      } else if (rowSeleccionado.detailResult === 1) {
        status = "1";
      } else if (rowSeleccionado.detailResult === 255) {
        status = "255";
      } else {
        status = "2";
      }
      setContenderStatus(status);
    };
  }

  const changeLoserContender = () => {
    if (props.IdSport == "TNT") {
      axios({
        method: "post",
        url:
          process.env.REACT_APP_API2_URL +
          "/Game/TNTLoseContender?idGame=" +
          props.IdGameTNT +
          "&teamNumber=" +
          selectedIdProfile +
          "&idUser=" +
          userInfo.userId +
          "&value=" +
          contenderStatus,
      }).then((response) => {
        console.log("response", response);
      });
    } else if (props.IdSport == "PROP") {
      axios({
        method: "post",
        url:
          process.env.REACT_APP_API2_URL +
          "/Game/PROPLoseContender?idGame=" +
          props.IdGames[0] +
          "&teamNumber=" +
          selectedIdProfile +
          "&idUser=" +
          userInfo.userId,
      }).then((response) => {
        console.log("response", response);
      });
    }
    props.searchGameValues();
    props.clearArray();
  };



  const updateWinnerTeam = () => {
    let req = {
      HomeScore: homeScore,
      VisitorScore: visitorScore,
      WinnerTeam: selectedWinner,
      IdGame: props.IdGames[0]
    }
    console.log(req)
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Game/WinnerTeam_Update",
      data: req,
    }).then((response) => {
      console.log("response", response);
    });

  }

  // useEffect(()=>{
  //   console.log(props.datesRow)
  // },[])

  const handleOk = () => {
    if (gameStatus != "B") {
      setIsLoading(true);
      if (flag) {
        changeLoserContender();
      }
      for (let i = 0; i < props.IdGames.length; i++) {
        let SetStatusRequest = {
          idGame: props.IdGames[i],
          sportType: sportType,
          shortGame: props.IdGames.length > 1 ? (props.datesRow[i].shortGame ? 1 : 0) : (isShortGame ? 1 : 0),
          local: local,
          online: online,
          noHookUps: noHookUps,
          noRelated: noRelated,
          dateChanged: dateChanged,
          timeChanged: timeChanged,
          pitcherChanged: pitcherChanged,
          gameStatus: gameStatus,
          visitorScore: (props.IdGames.length > 1 ? props.datesRow[i].visitorScore : visitorScore) ?? 0,
          homeScore: (props.IdGames.length > 1 ? props.datesRow[i].homeScore : homeScore) ?? 0,
          acceptAutoChanges: acceptAutoChanges,
          system: system,
          systemID: "N",
          idUser: userInfo.userId,
          idLeague: props.IdLeague,
        };
        axios({
          method: "post",
          url: process.env.REACT_APP_API2_URL + "/Game/GameSetStatus",
          data: SetStatusRequest,
        }).then((response) => {
          if (props.IdGames.length == 1 && props.IdSport.trim() == "MU" && selectedWinner !== 0) {
            updateWinnerTeam();
          }
          console.log("response", response);
          props.searchGameValues();
          setIsLoading(false);
          props.onClose();
          if (props.resetDatesRow) {
            props.resetDatesRow();
          }
        });
      }
    }
  };
  useEffect(() => {
    //Change for server api address
    //Profile Props',props )
    const url =
      process.env.REACT_APP_API2_URL +
      "/Game/Games_GameDataTNTV2?idGame=" +
      props.IdGames[0] +
      "&idLineType=" +
      props.IdLinetype;

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setGamesTNT(data);
      });
  }, []);

  useEffect(() => {
    console.log("props ======>", props);
    axios({
      method: "get",
      url:
        process.env.REACT_APP_API2_URL +
        "/Game/Games_GameData?idGame=" +
        props.IdGames[0] +
        "&idLineType=" +
        props.IdLinetype,
    })
      .then((response) => response.data)
      .then((data) => {
        data.forEach((x) => {
          setIdGame(x["idGame"]);
          setLocal(x["onLocal"]);
          setOnline(x["online"]);
          setGameStatus(x["gameStat"]);
          setNoHookUps(x["hookUps"]);
          setNoRelated(x["noRelated"]);
          setDateChanged(x["dateChanged"]);
          setTimeChanged(x["timeChanged"]);
          setPitcherChanged(x["pitcherChanged"]);
          setVisitorScore(x["visitorScore"]);
          setHomeScore(x["homeScore"]);
          setAcceptAutoChanges(x["acceptAutoChanges"]);
          setVisitorNumber(x["visitorNumber"]);
          setVisitorTeam(x["visitorTeam"]);
          setHomeNumber(x["homeNumber"]);
          setHomeTeam(x["homeTeam"]);
          setSelectedWinner(x["winnerTeam"]);
          setIsShortGame(x["shortGame"]);
        });

        setLoading(false);
      });
  }, []);

  return (
    <Dialog open={open} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Game Status
          </Typography>
        </Toolbar>
      </AppBar>
      {loading ? (
        <CircularProgress style={{ margin: "0 auto" }} />
      ) : (
        <React.Fragment>
          <br />
          <form className={classes.center}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={local}
                    onChange={handleChangeLocal}
                    color="primary"
                  />
                }
                label="Local"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={online}
                    onChange={handleChangeOnline}
                    color="primary"
                  />
                }
                label="Online"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={noHookUps}
                    onChange={handleChangeNoHookUps}
                    color="primary"
                  />
                }
                label="No Hookups"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={noRelated}
                    onChange={handleChangeNoRelated}
                    color="primary"
                  />
                }
                label="No Related"
              />
            </FormGroup>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dateChanged}
                    onChange={handleChangeDateChanged}
                    color="primary"
                  />
                }
                label="Date Changed"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={timeChanged}
                    onChange={handleChangeTimeChanged}
                    color="primary"
                  />
                }
                label="Time Changed"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acceptAutoChanges}
                    onChange={handleChangeAcceptAutoChanges}
                    color="primary"
                  />
                }
                label="Accept Auto Changes"
              />
            </FormGroup>
            <Divider />
            <FormGroup row>
              <h5>Pitcher Changed</h5>
            </FormGroup>
            <FormGroup row>
              <RadioGroup row>
                <FormControlLabel
                  // value="None"
                  control={
                    <Radio
                      checked={pitcherChanged == "0"}
                      onChange={handlePitcherChanged}
                      value="0"
                      label="None"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "None" }}
                    //disabled
                    />
                  }
                  label="None"
                  labelPlacement="end"
                />
                <FormControlLabel
                  //   value="Home"
                  control={
                    <Radio
                      checked={pitcherChanged == "1"}
                      onChange={handlePitcherChanged}
                      value="1"
                      label="Home"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Home" }}
                    // disabled
                    />
                  }
                  label="Home"
                  labelPlacement="end"
                />
                <FormControlLabel
                  //  value="Visitor"
                  control={
                    <Radio
                      checked={pitcherChanged == "2"}
                      onChange={handlePitcherChanged}
                      value="2"
                      label="Visitor"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Visitor" }}
                    // disabled
                    />
                  }
                  label="Visitor"
                  labelPlacement="end"
                />
                <FormControlLabel
                  //   value="Both"
                  control={
                    <Radio
                      checked={pitcherChanged == "3"}
                      onChange={handlePitcherChanged}
                      value="3"
                      label="Both"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Both" }}
                    // disabled
                    />
                  }
                  label="Both"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormGroup>
            <Divider />
            <FormGroup row>
              <RadioGroup row>
                <FormControlLabel
                  value="Open"
                  control={
                    <Radio
                      checked={gameStatus == "O"}
                      onChange={handleChangeStatus}
                      value="O"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Open" }}
                    />
                  }
                  label="Open"
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="Off Board"
                  control={
                    <Radio
                      checked={gameStatus == "D"}
                      //checked={gameStatus == 'B'}
                      onChange={handleChangeStatus}
                      //value="B"
                      value="D"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Off Board" }}
                    />
                  }
                  label="Off Board"
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="Cancel"
                  control={
                    <Radio
                      checked={gameStatus == "C"}
                      onChange={handleChangeStatus}
                      value="C"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Cancel" }}
                    />
                  }
                  label="Cancel"
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="Final"
                  control={
                    <Radio
                      checked={gameStatus == "F"}
                      onChange={handleChangeStatus}
                      value="F"
                      name="radio-button-time"
                      inputProps={{ "aria-label": "Final" }}
                    />
                  }
                  label="Final"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormGroup>
            <Divider />
            {props.IdGames.length == 1 ? (
              <React.Fragment>
                {props.IdSport != "TNT" && props.IdSport != "PROP" ? (
                  <React.Fragment>
                    <FormGroup row>
                      <h5>Completed Game</h5>
                    </FormGroup>
                    <FormGroup row>
                      <TextField
                        style={{ width: "400px" }}
                        type="text"
                        label="<no description>"
                        value={completedGame}
                        multiline={true}
                        rows="4"
                        onChange={handleChangeCompletedGame}
                        variant="outlined"
                      />
                    </FormGroup>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <FormGroup row>
                      <InputLabel
                        shrink
                        id="demo-simple-select-placeholder-label-label"
                      >
                        Contenders
                      </InputLabel>
                      {gamesTNT && gamesTNT.length > 0 && gamesTNT.map ? (
                        <Select
                          labelId="demo-simple-select-placeholder-label-label"
                          id="demo-simple-select-placeholder-label"
                          value={selectedIdProfile}
                          onChange={handleIdProfileChange}
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          {gamesTNT &&
                            gamesTNT.length > 0 &&
                            gamesTNT.map((row) => (
                              <MenuItem value={row.teamNumber}>
                                {row.teamNumber + " " + row.teamName}
                              </MenuItem>
                            ))}
                        </Select>
                      ) : (
                        ""
                      )}
                    </FormGroup>
                    <FormGroup row>
                      <RadioGroup row>
                        <FormControlLabel
                          value="Loser"
                          control={
                            <Radio
                              checked={contenderStatus === "0"}
                              onChange={handleChangeContenderStatus}
                              value="0"
                              name="radio-button-time"
                              inputProps={{ "aria-label": "Open" }}
                            />
                          }
                          label="Loser"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="Winner"
                          control={
                            <Radio
                              //checked={selectedValueStatus === 'D'}
                              checked={contenderStatus === "1"}
                              onChange={handleChangeContenderStatus}
                              value="1"
                              //value="D"
                              name="radio-button-time"
                              inputProps={{ "aria-label": "Off Board" }}
                            />
                          }
                          label="Winner"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="Pend"
                          control={
                            <Radio
                              checked={contenderStatus === "255"}
                              onChange={handleChangeContenderStatus}
                              value="255"
                              name="radio-button-time"
                              inputProps={{ "aria-label": "Cancel" }}
                            />
                          }
                          label="Pend"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="N/A"
                          control={
                            <Radio
                              checked={contenderStatus === "2"}
                              onChange={handleChangeContenderStatus}
                              value="2"
                              name="radio-button-time"
                              inputProps={{ "aria-label": "Final" }}
                            />
                          }
                          label="N/A"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormGroup>
                  </React.Fragment>
                )}
                <Divider />
                {props.IdSport != "PROP" ? (
                  <React.Fragment>
                    <FormGroup row className="w-[67%] !justify-between items-center m-auto flex">
                      <div>-</div>
                      <div className="flex gap-4">
                        {props.IdSport.trim() == "MU" && <h5>Winner</h5>}
                        <h5 className="w-[100px]">Score</h5>
                      </div>
                    </FormGroup>
                    <FormGroup row className="w-[70%] !justify-between items-center m-auto flex">
                      <span className="text-base font-semibold">[{visitorNumber}]{visitorTeam}</span>

                      <div className="flex gap-4">
                        {
                          props.IdSport.trim() == "MU" &&
                          <input type="radio" name="winnerSelection" value="visitor" checked={selectedWinner === 1} onChange={() => setSelectedWinner(1)} />
                        }
                        <TextField
                          style={{ width: "100px" }}
                          type="number"
                          value={visitorScore}
                          variant="outlined"
                          multiline={true}
                          onChange={handleChangeVisitorScore}
                        />
                      </div>
                    </FormGroup>
                    <FormGroup row className="w-[70%] !justify-between items-center m-auto flex">
                      <span className="text-base font-semibold">[{homeNumber}]{homeTeam}</span>

                      <div className="flex gap-4">
                        {
                          props.IdSport.trim() == "MU" &&
                          <input type="radio" name="winnerSelection" value="home" checked={selectedWinner === 2} onChange={() => setSelectedWinner(2)} />
                        }
                        <TextField
                          style={{ width: "100px" }}
                          type="number"
                          value={homeScore}
                          variant="outlined"
                          multiline={true}
                          onChange={handleChangeHomeScore}
                        />
                      </div>
                    </FormGroup>
                    {
                      (props.IdSport.trim() == "MLB" || props.LeagueName?.toLowerCase().includes("tennis")) &&
                      <FormGroup row className="w-[70%] flex !justify-end items-center m-auto">
                        <div className="font-semibold !text-xs">
                          Short Game
                          <Checkbox
                            checked={isShortGame}
                            onChange={handleShortGame}
                            color="primary"
                          />
                        </div>
                      </FormGroup>
                    }
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              ""
            )}
          </form>
        </React.Fragment>
      )}
      <DialogActions>
        {isLoading ? (
          <Loader height={100} width={100}></Loader>
        ) : (
          <div>
            <Button
              color="inherit"
              startIcon={<CancelIcon />}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
              onClick={handleOk}
            >
              Ok
            </Button>
          </div>
        )}
      </DialogActions>
    </Dialog>
  );
}
